import { Box, ListItemButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Alert from 'src/components/shared/ui/Alert'

import { WarningFillIcon } from 'src/components/shared/ui/Icons'
import { TipoMensaje } from 'src/enums/EscritosLegales'

import { theme } from 'src/providers/ThemeProvider'

type Props = {
  onClickAssign: () => void
  tipoMensaje: string
}

const styles = {
  alert: {
    marginTop: '16px',
    padding: theme.spacing(1, 1.5),

    '& .MuiAlert-message': {
      padding: '2px 0 0 0'
    }
  },

  title: {
    fontFamily: theme.corporate.primaryFont,
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '5px'
  },

  button: {
    width: 'fit-content',
    padding: '8px 0',
    color: theme.colors.byzantineBlue200,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',

    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  }
}

export default function AsignarExpedienteAlert({
  onClickAssign,
  tipoMensaje = TipoMensaje.ESCRITO.toString()
}: Props): JSX.Element {
  const { t } = useTranslation()

  const texts =
    tipoMensaje === TipoMensaje.NOTIFICACION.toString()
      ? {
          message: t('components.asignar_expediente_alert.message'),
          btnAction: t('actions.classify')
        }
      : {
          message: t('components.asignar_expediente_acuse_alert.message'),
          btnAction: t('actions.classify')
        }

  function renderIconType(): JSX.Element {
    return <WarningFillIcon sx={{ fontSize: '22px' }} htmlColor={theme.colors.saffron200} />
  }

  return (
    <Alert severity="warning" sx={styles.alert} icon={renderIconType()}>
      <Box sx={styles.title}>Clasificación</Box>
      <Box>{texts.message}</Box>
      <ListItemButton sx={styles.button} onClick={onClickAssign}>
        {texts.btnAction}
      </ListItemButton>
    </Alert>
  )
}
